export function detectMimeType(b64) {
    var signatures = {
        JVBERi0: "application/pdf",
        R0lGODdh: "image/gif",
        R0lGODlh: "image/gif",
        iVBORw0KGgo: "image/png",
        "/9j/": "image/jpg",
    };
    for (var s in signatures) {
        if (b64.indexOf(s) === 0) {
            return signatures[s];
        }
    }
}
export function getImageString(b64) {
    if (b64)
        return "data:" + detectMimeType(b64) + ";base64," + b64;
    else
        return "";
}
export function base64toPDF(respData) {
    var decodedPdfContents = window.atob(respData);
    var byteArrays = new Uint8Array(decodedPdfContents.length);
    for (var i = 0; i < decodedPdfContents.length; i++) {
        byteArrays[i] = decodedPdfContents.charCodeAt(i);
    }
    var blobs = new Blob([byteArrays.buffer], { type: "application/pdf" });
    var _pdfurls = URL.createObjectURL(blobs);
    var links = document.createElement("a");
    document.body.appendChild(links);
    links.href = _pdfurls;
    var evts = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
    });
    links.dispatchEvent(evts);
    window.URL.revokeObjectURL(_pdfurls);
    links.remove();
}
export var base64toPDFforceDownload = function (base64Data, fileName) {
    var byteCharacters = window.atob(base64Data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    // Create a Blob from the decoded data
    var blob = new Blob([byteArray], { type: "application/pdf" });
    // Create a download link
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    // Set the "download" attribute to force the download
    link.setAttribute("download", fileName);
    // Append the link to the document and trigger the click event
    document.body.appendChild(link);
    link.click();
    // Remove the link from the document
    document.body.removeChild(link);
};
export var openBase64PDFInNewTab = function (base64Data, fileName) {
    var sliceSize = 1024;
    var byteCharacters = window.atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);
    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);
        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset)
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    var blob = new Blob(byteArrays, { type: "application/pdf" });
    var nav = window.navigator;
    if (nav && nav.msSaveOrOpenBlob)
        nav.msSaveOrOpenBlov(blob, "".concat(fileName, ".pdf"));
    else
        window.open(URL.createObjectURL(blob));
};
